import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const DepartmentDetail = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <>
            <section id="team_area" className='bg-white pb-0' >
                <div className="container">
                    {/* <Heading heading="Expert Team" para="This is our expert team members of AndShop" /> */}
                    <div className="row">
                        {props.TeamData.map((data, index) => (
                            <div className="col-lg-4 mb-1" key={index}>
                                <div className="team_slider">
                                    <Link
                                    to={{
                                        pathname: `/department-details/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                           , state: {
                                                                            department: data
                                                                           }
                                                                       }}
                                    
                                    >
                                        <h4 className='mb-1 font-weight-light'>{data.title[i18n.language]}</h4>
                                        <div className="team-single">
                                            <div className="position-relative">
                                                <img src={process.env.REACT_APP_IMG_URL + data.image} className="depImg" />
                                                <div className="departViewdetails">

                                                    {/* <p className='small text-body lines'>{data.description[i18n.language]?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}</p> */}
                                                    {t('viewdetails')}
                                                </div>
                                            </div>

                                        </div>
                                    </Link>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default DepartmentDetail
